import sidekickLogo from '../../assets/images/sidekick-logo.svg';
import sidekickLogo2 from '../../assets/images/sidekick-logo-2.svg';
import engageLogo from '../../assets/images/engage-logo.svg';
import investLogo from '../../assets/images/invest-logo.svg';
import chatBubbleIcon from '../../assets/images/chat-bubble-icon.svg';

export interface TileConfig {
    id: number;
    name: string;
    desc: string;
    subtitle: string;
    permission: string;
    imgSrc: string;
    imgsrcListingPage: string;
    route?: string;
    upcoming?: boolean;
    disable?: boolean;
}

export const TILES: TileConfig[] = [
    {
        id: 1,
        name: "Sidekick",
        desc: "AI Conversational Search",
        subtitle: "Your central place to review conversations, feedback, and insights to improve the Sidekick experience.",
        permission: "rag_admin_access",
        imgSrc: sidekickLogo,
        imgsrcListingPage: sidekickLogo2,
        route: "/sidekick",
    },
    {
        id: 2,
        name: "Engage",
        desc: "Actionable & Insightful Analytics",
        subtitle: "This page serves as your central hub to help you navigate everything at Panviva",
        permission: "engage_admin_access",
        imgSrc: engageLogo,
        imgsrcListingPage: engageLogo,
        upcoming: true,
        disable: true,
    },
    {
        id: 3,
        name: "Invest",
        desc: "Micro-learning",
        subtitle: "This page serves as your central hub to help you navigate everything at Panviva",
        permission: "invest_admin_access",
        imgSrc: investLogo,
        imgsrcListingPage: investLogo,
        upcoming: true,
        disable: true,
    },
];

export interface SubTileConfig {
    id: number;
    name: string;
    title: string;
    desc: string;
    iconSrc?: string;
    route?: string;
}

export const SIDEKICK_SUB_TILES: SubTileConfig[] = [
    {
        id: 1,
        name: "chat-history",
        title: "Sidekick Chat History & Feedback",
        desc: "Understand how users interact with Sidekick by reviewing conversations and feedback to identify issues and improve your knowledge base.",
        iconSrc: chatBubbleIcon,
        route: "/sidekick/chat-history",
    },
];

export const INVEST_SUB_TILES: SubTileConfig[] = [
    {
        id: 1,
        name: "invest-analytics",
        title: "Invest Analytics",
        desc: "Description for Invest",
    },
];

export const ENGAGE_SUB_TILES: SubTileConfig[] = [
    {
        id: 1,
        name: "engage-dashboard",
        title: "Engage Dashboard",
        desc: "Description for Engage",
    },
];

/**
 * Maps tile routes to their corresponding sub-tile arrays
 * Used by ListingPage to dynamically display the correct tiles based on the current route
 */
export const SUB_TILES_MAP: Record<string, SubTileConfig[]> = {
    "/sidekick": SIDEKICK_SUB_TILES,
    "/engage": ENGAGE_SUB_TILES,
    "/invest": INVEST_SUB_TILES,
};
